module.exports = __webpack_public_path__ + "img/facil.ab975c74.jpg";